var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50 15.9099C68.0192 15.9099 82.6265 30.5173 82.6265 48.5364H74.2932C74.2932 35.1196 63.4167 24.2433 50 24.2433C36.5832 24.2433 25.7069 35.1196 25.7069 48.5364H17.3735C17.3735 30.5173 31.9809 15.9099 50 15.9099Z",
    fill: "#4c2e61"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.9999 1.11987C76.1874 1.11987 97.4166 22.349 97.4166 48.5365H89.0833C89.0833 26.9514 71.5851 9.45321 49.9999 9.45321C28.4148 9.45321 10.9166 26.9514 10.9166 48.5365H2.58325C2.58325 22.349 23.8124 1.11987 49.9999 1.11987Z",
    fill: "#4c2e61"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.9999 30.0278C60.2219 30.0278 68.5085 38.3145 68.5085 48.5365H60.1752C60.1752 42.9168 55.6195 38.3612 49.9999 38.3612C44.3802 38.3612 39.8245 42.9168 39.8245 48.5365H31.4912C31.4912 38.3145 39.7779 30.0278 49.9999 30.0278Z",
    fill: "#4c2e61"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.2ca69fc2aa0a395ac05f3d800b05b691.svg";
export { ForwardRef as ReactComponent };